export default function convertResponsiveValue<T>(value: T | T[]): T | T[] {
  return value;
}
